<template>
  <div class="profile">
<!--    <div class="banner">-->
<!--      <img src="../assets/profileBanner.jpg" />-->
<!--    </div>-->
    <div class="content">
      <h2>招聘要求</h2>
      <div>
        <div class="label">一、招聘对象</div>
        <p>2027届境内外高校大学本科及以上全日制、应届生毕业生。</p>
        <div class="label">二、基本要求</div>
        <p>1.遵守国家法律法规，政治素质高，责任心强，无违规违纪行为。</p>
        <p>2.思想上进，品行端正，身体健康、爱岗敬业，恪守职业道德。</p>
        <p>3.成绩优良，具备较突出的组织协调和沟通能力，良好的服务意识和团队协作精神。</p>
        <p>4.双一流学科及获得“优秀毕业生”“三好学生”等称号的应届毕业生优先考虑。</p>
        <div class="label">三、简历投递</div>
        <p>请登录企业官网（<a href="http://www.bgi.com.cn" target="_blank">www.bgi.com.cn</a>），点击“加入北勘”进行个人信息填写与简历投递，“意向工作地点”选择北京或（深圳/广州/佛山），个人简历的文件命名格式：“专业-姓名-学历-学校”。</p>

        <div class="label">四、联系方式</div>
        <p>联系部门：北京市勘察设计研究院有限公司人力资源部</p>
        <p><span class="lianxiren">联系人</span>：苏老师、张老师</p>
        <p style="display: flex">
            <span style="width: 120px">联系电话：</span>
            <span style="">
                <div style="text-indent: 0">010-63951970</div>
                <div style="text-indent: 0">010-63987285</div>
            </span>


        </p>
<!--        <p>邮　　箱：bgi2005@sina.com</p>-->
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "../base/Footer";

export default {
  name: "Profile",
  props: {},
  components: { Footer },
  methods: {
    handleSelect(key, keyPath) {},
  },
  data() {
    return {
      search: "",
      activeIndex: "1",
    };
  },
};
</script>

<style scoped lang="less">
.profile {
  width: 100%;
  background: #fff;
  .banner {
    margin-top: 60px;
    height: 250px;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .content {
    margin: 100px auto 50px;
    width: 1000px;
    background: #fff;
    h2 {
      font-size: 26px;
      margin: 30px 0;
      letter-spacing: 8px;
      font-weight: 700;
      color: #102b6a;
    }
    .label{
      text-align: left;
      font-weight: 600;
      font-size: 18px;
      margin-bottom: 30px;
      margin-top: 30px;
    }

    p {
      line-height: 40px;
      margin-bottom: 15px;
      text-align: left;
      text-indent: 35px;
    }
    .lianxiren{
      letter-spacing: 5px;

    }

    /*span {*/
    /*  font-size: 20px;*/
    /*  color: #006eab;*/
    /*  font-weight: 600;*/
    /*}*/
  }
}
</style>
